import { useSelector } from 'react-redux'

import { currentUserSelector } from '../redux/selectors/users'

export function useHasFeatureFlag(flag: string) {
  const user = useSelector(currentUserSelector)
  return Boolean(user?.featureFlags?.[flag])
}

export function useHasPlaidBankAccountFlag() {
  return useHasFeatureFlag('plaid-bank-account')
}

export function useHasReplacePlaidAccountFlag() {
  return useHasFeatureFlag('plaid-replace-account')
}

export function useHasDisableMcDotValidationFlag() {
  return useHasFeatureFlag('disable-mc-dot-validation')
}

export function useContractorBusinessAllowAnyAdminOnboard() {
  return useHasFeatureFlag('public-contractor-business-allow-any-admin-onboard')
}

export function useSkipPermissionCheckFeature() {
  return useHasFeatureFlag('skip-permission-check')
}

export function useHasSkipStripeCardChecksFlag() {
  return useHasFeatureFlag('skip-stripe-card-checks')
}

export function useHasRecommendedSort() {
  return useHasFeatureFlag('p-rex-show-in-front-end')
}

export function useHasAnnualBilling() {
  return useHasFeatureFlag('public-annual-billing')
}

export function useHasHosEtaBrokerTrackingFlag() {
  return useHasFeatureFlag('hos_etas_for_self_service_job_tracking')
}

export function useHasContractorPaymentsCtCashBalanceInstantPayEnabled() {
  return useHasFeatureFlag('public-contractor-payments-ct-cash-balance-instant-pay-enabled')
}

export function useOauthDisablePopupFlag() {
  return useHasFeatureFlag('public-oauth-disable-popup')
}

export const useHasOnboardingInsuranceFlag = () => {
  return useHasFeatureFlag('public-onboarding-insurance')
}

export function useHasL2oLinearOnboardingFlag() {
  return useHasFeatureFlag('public-l2o-linear-onboarding')
}

export function useHasCheckrSeparatePackages() {
  return useHasFeatureFlag('public_checkr_separate_packages_flag')
}

export function useHasL2oTruckLeaseApplicationFlag() {
  return useHasFeatureFlag('public-l2o-truck-lease-application')
}

export function usePlaidConsumerReportFlag() {
  return useHasFeatureFlag('public-plaid-consumer-report-flag')
}

export function useHasDecompressSearchResultsFlag() {
  return useHasFeatureFlag('decompress-search-results')
}

export function useHasStripeBusinessVerificationFlag() {
  return useHasFeatureFlag('public-stripe-business-verification')
}
